"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("../../../utils/styled-components"));

var _utils = require("../../../utils");

var _excluded = ["onClick", "onBlur", "onFocus", "ref", "children", "dataTest"];

var _templateObject;

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
} // fillStyle


var fillStyle = function fillStyle(fillContainer) {
  if (fillContainer === "horizontal") return "width: 100%;";
  if (fillContainer === "vertical") return "height: 100%;";
  if (fillContainer) return " width: 100%; height: 100%; max-width: none; flex: 1 0 auto;";
  return undefined;
};

var StyledButton = (0, _styledComponents["default"])(function (_ref) {
  var onClick = _ref.onClick,
      onBlur = _ref.onBlur,
      onFocus = _ref.onFocus,
      ref = _ref.ref,
      children = _ref.children,
      dataTest = _ref.dataTest,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("button", _defineProperty({
    dataTest: dataTest,
    onClick: onClick,
    onBlur: onBlur,
    onFocus: onFocus,
    ref: ref,
    className: props.className,
    style: props.style
  }, "dataTest", dataTest), children);
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  cursor: pointer;\n  font: inherit;\n  text-decoration: none;\n\n  ", "\n  ", ";\n  ", ";\n  ", "\n  border-radius: ", ";\n\n  padding: ", ";\n"])), function (props) {
  return props.fill && fillStyle(props.fill);
}, function (props) {
  return props.disabled && "pointer-events:none";
}, function (props) {
  return props.border ? "border:".concat(props.border.width, "px solid ").concat(props.border.color) : "border:none";
}, function (props) {
  return props.background && (0, _utils.backgroundStyle)(props.background, props.theme);
}, function (_ref2) {
  var shape = _ref2.shape;
  var value;

  switch (shape) {
    case "circle":
      value = "25px";
      break;

    case "round":
      value = "8px";
      break;
  }

  return value;
}, function (_ref3) {
  var size = _ref3.size;
  var value;

  switch (size) {
    case "xs":
      value = "2px 5px";
      break;

    case "sm":
      value = "5px 8px";
      break;

    case "md":
      value = "8px 13px";
      break;

    case "lg":
      value = "15px 18px";
      break;

    case "xl":
      value = "20px 24px";
      break;

    case "xxl":
      value = "23px 28px";
      break;

    default:
      value = "2px 5px";
  }

  return value;
});
StyledButton.defaultProps = {
  type: "primary",
  size: "md",
  border: false
};
var _default = StyledButton;
exports["default"] = _default;